import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KeyCode from '../util/KeyCode';
import dayjs from '../dayjs';
import { formatDate } from '../util';
var emptyFn = function () { };
injectStyle("components/DatePicker/rc-calendar/style/common/DateInput.css", "[data-dui-0-122-5~=\"dui-calendar-date-input-wrap\"]{overflow:hidden}[data-dui-0-122-5~=\"dui-calendar-input\"]{width:100%;height:22px;border:1px solid transparent;color:var(--text-ultrastrong,rgba(0,0,0,.88));line-height:1.5;outline:none}[data-dui-0-122-5~=\"dui-calendar-input-wrap\"]{position:relative;padding:6px;border-bottom:1px solid #ebebeb}[data-dui-0-122-5~=\"dui-calendar-input-wrap\"]:after{clear:both;content:\"\"}[data-dui-0-122-5~=\"dui-calendar-input-invalid\"]{border-color:#ed593d}[data-dui-0-122-5~=\"dui-calendar-clear-btn\"]{position:absolute;z-index:1;top:6px;right:6px;overflow:hidden;width:20px;height:20px;margin:0;cursor:pointer;line-height:20px;text-align:center}[data-dui-0-122-5~=\"dui-calendar-clear-btn\"]:after{display:inline-block;width:20px;color:#999;content:\"x\";font-size:12px;line-height:1;-webkit-transition:color .3s ease;transition:color .3s ease}[data-dui-0-122-5~=\"dui-calendar-clear-btn\"]:hover:after{color:#5c5c5c}");
var cachedSelectionStart;
var cachedSelectionEnd;
var dateInputInstance;
var DateInput = (function (_super) {
    __extends(DateInput, _super);
    function DateInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onClear = function () {
            var onClear = _this.props.onClear;
            _this.setState({
                str: '',
            });
            onClear(null);
        };
        _this.onInputChange = function (event) {
            var str = event.target.value;
            var _a = _this.props, disabledDate = _a.disabledDate, format = _a.format, onChange = _a.onChange, selectedValue = _a.selectedValue, propsValue = _a.value;
            if (!str) {
                onChange(null);
                _this.setState({
                    invalid: false,
                    str: str,
                });
                return;
            }
            var parsed = dayjs(str, format);
            if (!parsed.isValid()) {
                _this.setState({
                    invalid: true,
                    str: str,
                });
                return;
            }
            var value = propsValue.clone();
            value
                .year(parsed.year())
                .month(parsed.month())
                .date(parsed.date())
                .hour(parsed.hour())
                .minute(parsed.minute())
                .second(parsed.second())
                .millisecond(parsed.millisecond());
            if (disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(value)) {
                _this.setState({
                    invalid: true,
                    str: str,
                });
                return;
            }
            if (!(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.isSame(value))) {
                _this.setState({
                    invalid: false,
                    str: str,
                });
                onChange(value);
            }
        };
        _this.onFocus = function () {
            _this.setState({ hasFocus: true });
        };
        _this.onKeyDown = function (event) {
            var keyCode = event.keyCode;
            var _a = _this.props, onSelect = _a.onSelect, value = _a.value, disabledDate = _a.disabledDate;
            if (keyCode !== KeyCode.ENTER || !onSelect) {
                return;
            }
            var validateDate = !(disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(value));
            if (validateDate) {
                onSelect(value.clone());
            }
            event.preventDefault();
        };
        var selectedValue = props.selectedValue, format = props.format;
        _this.state = {
            str: formatDate(selectedValue, format),
            invalid: false,
            hasFocus: false,
        };
        return _this;
    }
    DateInput.saveDateInput = function (dateInput) {
        dateInputInstance = dateInput;
    };
    DateInput.getInstance = function () {
        return dateInputInstance;
    };
    DateInput.getDerivedStateFromProps = function (nextProps, state) {
        var newState = {};
        if (dateInputInstance) {
            cachedSelectionStart = dateInputInstance.selectionStart;
            cachedSelectionEnd = dateInputInstance.selectionEnd;
        }
        var selectedValue = nextProps.selectedValue;
        if (!state.hasFocus) {
            newState = {
                str: formatDate(selectedValue, nextProps.format),
                invalid: false,
            };
        }
        return newState;
    };
    DateInput.prototype.componentDidUpdate = function () {
        var _a = this.state, hasFocus = _a.hasFocus, invalid = _a.invalid;
        if (dateInputInstance && hasFocus && !invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
            dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
        }
    };
    DateInput.prototype.onBlur = function () {
        this.setState(function (_, prevProps) { return ({
            hasFocus: false,
            str: formatDate(prevProps.value, prevProps.format),
        }); });
    };
    DateInput.prototype.render = function () {
        var _a;
        var props = this.props;
        var _b = this.state, invalid = _b.invalid, str = _b.str;
        var locale = props.locale, prefixCls = props.prefixCls, placeholder = props.placeholder, clearIcon = props.clearIcon, inputMode = props.inputMode;
        return (h("div", { className: prefixCls + "-input-wrap" },
            h("div", { className: prefixCls + "-date-input-wrap" },
                h("input", { ref: DateInput.saveDateInput, disabled: props.disabled, inputMode: inputMode, placeholder: placeholder, value: str, className: classNames(prefixCls + "-input", (_a = {},
                        _a[prefixCls + "-input-invalid"] = invalid,
                        _a)), onBlur: this.onBlur, onChange: this.onInputChange, onFocus: this.onFocus, onKeyDown: this.onKeyDown })),
            props.showClear ? (h("span", { role: "button", tabIndex: "0", title: locale.clear, onClick: this.onClear, onKeyDown: emptyFn }, clearIcon || h("span", { className: prefixCls + "-clear-btn" }))) : null));
    };
    return DateInput;
}(React.Component));
DateInput.propTypes = {
    clearIcon: PropTypes.node,
    disabled: PropTypes.bool,
    disabledDate: PropTypes.func,
    format: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    inputMode: PropTypes.string,
    locale: PropTypes.shape({
        clear: PropTypes.string,
    }),
    placeholder: PropTypes.string,
    prefixCls: PropTypes.string,
    selectedValue: PropTypes.instanceOf(dayjs),
    showClear: PropTypes.bool,
    value: PropTypes.instanceOf(dayjs),
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    onSelect: PropTypes.func,
};
DateInput.defaultProps = {
    clearIcon: null,
    disabled: false,
    disabledDate: undefined,
    format: undefined,
    inputMode: undefined,
    locale: {},
    onChange: emptyFn,
    onClear: emptyFn,
    onSelect: emptyFn,
    placeholder: '',
    prefixCls: '',
    selectedValue: undefined,
    showClear: false,
    value: undefined,
};
export default DateInput;
